import gql from 'graphql-tag'

/**
 * Query to fetch paginated vehicle records for a given vehicle list.
 * Uses server-side pagination via limit/offset.
 */
export const GET_VEHICLE_RECORDS_Q = gql`
  query GetVehicleRecords($vehicleListId: Int!, $limit: Int, $offset: Int) {
    vehicleRecords(
      queryVehicleRecordsInput: {
        vehicleListId: $vehicleListId
        limit: $limit
        offset: $offset
      }
    ) {
      items {
        id
        vehicleListId
        captureTimestamp
        plateText
        brand
        model
        type
        createdAt
      }
      pagination {
        offset
        limit
        totalCount
      }
    }
  }
`
